<template>
  <!-- Direct notifications (в порядке enum NotificationType) -->
  <template v-if="notification.type === NotificationType.AnswerMyProblem">
    <nuxt-link v-if="userLink" :to="userLink" class="user-link">{{ userName }}</nuxt-link>
    <span v-else class="user-text">{{ userName }}</span>
    <span> answered my question </span>
    <nuxt-link v-if="problemLink" :to="problemLink" class="problem-link">{{ problemTitle }}</nuxt-link>
    <span v-else class="problem-text">{{ problemTitle }}</span>
  </template>

  <template v-else-if="notification.type === NotificationType.CommentMyDiary">
    <nuxt-link v-if="userLink" :to="userLink" class="user-link">{{ userName }}</nuxt-link>
    <span v-else class="user-text">{{ userName }}</span>
    <span> commented on your diary {{ addDateFormatted }} - </span>
    <nuxt-link v-if="diaryLink" :to="diaryLink" class="diary-link">{{ diaryName }}</nuxt-link>
    <span v-else class="diary-text">{{ diaryName }}</span>
  </template>

  <template v-else-if="notification.type === NotificationType.CommentMyProfile">
    <nuxt-link v-if="userLink" :to="userLink" class="user-link">{{ userName }}</nuxt-link>
    <span v-else class="user-text">{{ userName }}</span>
    <span> commented on your profile {{ addDateFormatted }}</span>
  </template>

  <template v-else-if="notification.type === NotificationType.CommentMyVideo">
    <nuxt-link v-if="userLink" :to="userLink" class="user-link">{{ userName }}</nuxt-link>
    <span v-else class="user-text">{{ userName }}</span>
    <span> commented on your video {{ addDateFormatted }}</span>
  </template>

  <template v-else-if="notification.type === NotificationType.ComplaintMyComment">
    <span>A complaint has been submitted about your comment {{ addDateFormatted }}</span>
  </template>

  <template v-else-if="notification.type === NotificationType.ComplaintMyDiary">
    <span>A complaint has been submitted about your diary {{ addDateFormatted }} - </span>
    <nuxt-link v-if="diaryLink" :to="diaryLink" class="diary-link">{{ diaryName }}</nuxt-link>
    <span v-else class="diary-text">{{ diaryName }}</span>
  </template>

  <template v-else-if="notification.type === NotificationType.ComplaintMyProfile">
    <span>A complaint has been submitted about your profile {{ addDateFormatted }}</span>
  </template>

  <template v-else-if="notification.type === NotificationType.ComplaintMyVideo">
    <span>A complaint has been submitted about your video {{ addDateFormatted }}</span>
  </template>

  <template v-else-if="notification.type === NotificationType.FeatureBrand">
    <nuxt-link v-if="brandLink" :to="brandLink" class="brand-link">{{ brandName }}</nuxt-link>
    <span v-else class="brand-text">{{ brandName }}</span>
    <span> has been featured {{ addDateFormatted }}</span>
  </template>

  <template v-else-if="notification.type === NotificationType.FeatureBlog">
    <nuxt-link v-if="userLink" :to="userLink" class="user-link">{{ userName }}</nuxt-link>    
    <span> featured blog {{ addDateFormatted }} - </span>
    <nuxt-link v-if="blogLink" :to="blogLink" class="blog-text">{{ blogName }}</nuxt-link>
  </template>

  <template v-else-if="notification.type === NotificationType.FeatureComment">
    <span>Comment has been featured {{ addDateFormatted }}</span>
  </template>

  <template v-else-if="notification.type === NotificationType.FeatureDiary">
    <span>Diary has been featured {{ addDateFormatted }} - </span>
    <nuxt-link v-if="diaryLink" :to="diaryLink" class="diary-link">{{ diaryName }}</nuxt-link>
    <span v-else class="diary-text">{{ diaryName }}</span>
  </template>

  <template v-else-if="notification.type === NotificationType.FeatureProduct">
    <span>Product has been featured {{ addDateFormatted }} - </span>
    <nuxt-link v-if="productLink" :to="productLink" class="product-link">{{ productName }}</nuxt-link>
    <span v-else class="product-text">{{ productName }}</span>
  </template>

  <template v-else-if="notification.type === NotificationType.FeatureUser">
    <span>Profile has been featured {{ addDateFormatted }}</span>
  </template>

  <template v-else-if="notification.type === NotificationType.FeatureVideo">
    <span>Video has been featured {{ addDateFormatted }}</span>
  </template>

  <template v-else-if="notification.type === NotificationType.FollowMe">
    <nuxt-link v-if="userLink" :to="userLink" class="user-link">{{ userName }}</nuxt-link>
    <span v-else class="user-text">{{ userName }}</span>
    <span> started following you {{ addDateFormatted }}</span>
  </template>

  <template v-else-if="notification.type === NotificationType.FollowMyDiary">
    <nuxt-link v-if="userLink" :to="userLink" class="user-link">{{ userName }}</nuxt-link>
    <span v-else class="user-text">{{ userName }}</span>
    <span> started following your diary {{ addDateFormatted }} - </span>
    <nuxt-link v-if="diaryLink" :to="diaryLink" class="diary-link">{{ diaryName }}</nuxt-link>
    <span v-else class="diary-text">{{ diaryName }}</span>
  </template>

  <template v-else-if="notification.type === NotificationType.FollowingBrandCreatedComment">
    <nuxt-link v-if="userLink" :to="userLink" class="brand-link">{{ userName }}</nuxt-link>
    <span v-else class="brand-text">{{ brandName }}</span>
    <span> commented on a diary {{ addDateFormatted }}</span>
  </template>

  <template v-else-if="notification.type === NotificationType.FollowingBrandCreatedDiary">
    <nuxt-link v-if="userLink" :to="userLink" class="brand-link">{{ userName }}</nuxt-link>
    <span v-else class="brand-text">{{ brandName }}</span>
    <span> started a new diary {{ addDateFormatted }} - </span>
    <nuxt-link v-if="diaryLink" :to="diaryLink" class="diary-link">{{ diaryName }}</nuxt-link>
    <span v-else class="diary-text">{{ diaryName }}</span>
  </template>

  <template v-else-if="notification.type === NotificationType.FollowingBrandCreatedHarvest">
    <nuxt-link v-if="userLink" :to="userLink" class="brand-link">{{ userName }}</nuxt-link>
    <span v-else class="brand-text">{{ brandName }}</span>
    <span> harvested their diary {{ addDateFormatted }} - </span>
    <nuxt-link v-if="diaryLink" :to="diaryLink" class="diary-link">{{ diaryName }}</nuxt-link>
    <span v-else class="diary-text">{{ diaryName }}</span>
  </template>

  <template v-else-if="notification.type === NotificationType.FollowingBrandCreatedProduct">
    <nuxt-link v-if="brandLink" :to="brandLink" class="brand-link">{{ brandName }}</nuxt-link>
    <span v-else class="brand-text">{{ brandName }}</span>
    <span> released a new product {{ addDateFormatted }} - </span>
    <nuxt-link v-if="productLink" :to="productLink" class="product-link">{{ productName }}</nuxt-link>
    <span v-else class="product-text">{{ productName }}</span>
  </template>

  <template v-else-if="notification.type === NotificationType.FollowingBrandCreatedWeek">
    <nuxt-link v-if="brandLink" :to="brandLink" class="brand-link">{{ brandName }}</nuxt-link>
    <span v-else class="brand-text">{{ brandName }}</span>
    <span> updated their diary {{ addDateFormatted }} - </span>
    <nuxt-link v-if="diaryLink" :to="diaryLink" class="diary-link">{{ diaryName }}</nuxt-link>
    <span v-else class="diary-text">{{ diaryName }}</span>
  </template>

  <template v-else-if="notification.type === NotificationType.FollowingDiaryCreatedComment">
    <span>Diary </span>
    <nuxt-link v-if="diaryLink" :to="diaryLink" class="diary-link">{{ diaryName }}</nuxt-link>
    <span v-else class="diary-text">{{ diaryName }}</span>
    <span> you follow received a new comment {{ addDateFormatted }}</span>
  </template>

  <template v-else-if="notification.type === NotificationType.FollowingDiaryCreatedHarvest">
    <span>Diary </span>
    <nuxt-link v-if="diaryLink" :to="diaryLink" class="diary-link">{{ diaryName }}</nuxt-link>
    <span v-else class="diary-text">{{ diaryName }}</span>
    <span> you follow was harvested {{ addDateFormatted }}</span>
  </template>

  <template v-else-if="notification.type === NotificationType.FollowingDiaryCreatedProblem">
    <span>A new grow question was posted for diary </span>
    <nuxt-link v-if="diaryLink" :to="diaryLink" class="diary-link">{{ diaryName }}</nuxt-link>
    <span v-else class="diary-text">{{ diaryName }}</span>
    <span> you follow {{ addDateFormatted }}</span>
  </template>

  <template v-else-if="notification.type === NotificationType.FollowingDiaryCreatedWeek">
    <span>Diary </span>
    <nuxt-link v-if="diaryLink" :to="diaryLink" class="diary-link">{{ diaryName }}</nuxt-link>
    <span v-else class="diary-text">{{ diaryName }}</span>
    <span> you follow was updated {{ addDateFormatted }}</span>
  </template>

  <template v-else-if="notification.type === NotificationType.FollowingProductCreatedComment">
    <nuxt-link v-if="userLink" :to="userLink" class="user-link">{{ userName }}</nuxt-link>
    <span v-else class="user-text">{{ userName }}</span>
    <span> posted a new comment {{ addDateFormatted }}</span>
  </template>

  <template v-else-if="notification.type === NotificationType.FollowingProductCreatedDiary">
    <nuxt-link v-if="userLink" :to="userLink" class="user-link">{{ userName }}</nuxt-link>
    <span v-else class="user-text">{{ userName }}</span>
    <span> has a new diary {{ addDateFormatted }} - </span>
    <nuxt-link v-if="diaryLink" :to="diaryLink" class="diary-link">{{ diaryName }}</nuxt-link>
    <span v-else class="diary-text">{{ diaryName }}</span>
  </template>

  <template v-else-if="notification.type === NotificationType.FollowingProductCreatedHarvest">
    <nuxt-link v-if="userLink" :to="userLink" class="user-link">{{ userName }}</nuxt-link>
    <span v-else class="user-text">{{ userName }}</span>
    <span> diary was harvested {{ addDateFormatted }} - </span>
    <nuxt-link v-if="diaryLink" :to="diaryLink" class="diary-link">{{ diaryName }}</nuxt-link>
    <span v-else class="diary-text">{{ diaryName }}</span>
  </template>

  <template v-else-if="notification.type === NotificationType.FollowingProductCreatedWeek">
    <nuxt-link v-if="userLink" :to="userLink" class="user-link">{{ userName }}</nuxt-link>
    <span v-else class="user-text">{{ userName }}</span>
    <span> diary was updated {{ addDateFormatted }} - </span>
    <nuxt-link v-if="diaryLink" :to="diaryLink" class="diary-link">{{ diaryName }}</nuxt-link>
    <span v-else class="diary-text">{{ diaryName }}</span>
  </template>

  <template v-else-if="notification.type === NotificationType.FollowingUserCreatedComment">
    <nuxt-link v-if="userLink" :to="userLink" class="user-link">{{ userName }}</nuxt-link>
    <span v-else class="user-text">{{ userName }}</span>
    <span> commented on a diary {{ addDateFormatted }}</span>
  </template>

  <template v-else-if="notification.type === NotificationType.FollowingUserCreatedDiary">
    <nuxt-link v-if="userLink" :to="userLink" class="user-link">{{ userName }}</nuxt-link>
    <span v-else class="user-text">{{ userName }}</span>
    <span> started a new diary {{ addDateFormatted }} - </span>
    <nuxt-link v-if="diaryLink" :to="diaryLink" class="diary-link">{{ diaryName }}</nuxt-link>
    <span v-else class="diary-text">{{ diaryName }}</span>
  </template>

  <template v-else-if="notification.type === NotificationType.FollowingUserCreatedHarvest">
    <nuxt-link v-if="userLink" :to="userLink" class="user-link">{{ userName }}</nuxt-link>
    <span v-else class="user-text">{{ userName }}</span>
    <span> harvested their diary {{ addDateFormatted }} - </span>
    <nuxt-link v-if="diaryLink" :to="diaryLink" class="diary-link">{{ diaryName }}</nuxt-link>
    <span v-else class="diary-text">{{ diaryName }}</span>
  </template>

  <template v-else-if="notification.type === NotificationType.FollowingUserCreatedProblem">
    <nuxt-link v-if="userLink" :to="userLink" class="user-link">{{ userName }}</nuxt-link>
    <span v-else class="user-text">{{ userName }}</span>
    <span> posted a new grow question {{ addDateFormatted }} - </span>
    <nuxt-link v-if="problemLink" :to="problemLink" class="problem-link">{{ problemTitle }}</nuxt-link>
    <span v-else class="problem-text">{{ problemTitle }}</span>
  </template>

  <template v-else-if="notification.type === NotificationType.FollowingUserCreatedVideo">
    <nuxt-link v-if="userLink" :to="userLink" class="user-link">{{ userName }}</nuxt-link>
    <span v-else class="user-text">{{ userName }}</span>
    <span> posted a new video {{ addDateFormatted }}</span>
  </template>

  <template v-else-if="notification.type === NotificationType.FollowingUserCreatedWeek">
    <nuxt-link v-if="userLink" :to="userLink" class="user-link">{{ userName }}</nuxt-link>
    <span v-else class="user-text">{{ userName }}</span>
    <span> updated their diary {{ addDateFormatted }} - </span>
    <nuxt-link v-if="diaryLink" :to="diaryLink" class="diary-link">{{ diaryName }}</nuxt-link>
    <span v-else class="diary-text">{{ diaryName }}</span>
  </template>

  <template v-else-if="notification.type === NotificationType.GiveawayWinnerChoosing">
    <span>Winners are being chosen for {{ contestName }} {{ addDateFormatted }}</span>
  </template>

  <template v-else-if="notification.type === NotificationType.GiveawayWinnerDeclared">
    <span>Winners have been announced for {{ contestName }} {{ addDateFormatted }}</span>
  </template>

  <template v-else-if="notification.type === NotificationType.GiveawayWon">
    <span>Congratulations! You won {{ contestName }} {{ addDateFormatted }}</span>
  </template>

  <template v-else-if="notification.type === NotificationType.LikeMyComment">
    <nuxt-link v-if="userLink" :to="userLink" class="user-link">{{ userName }}</nuxt-link>
    <span v-else class="user-text">{{ userName }}</span>
    <span> liked your comment {{ addDateFormatted }}</span>
  </template>

  <template v-else-if="notification.type === NotificationType.LikeMyVideo">
    <nuxt-link v-if="userLink" :to="userLink" class="user-link">{{ userName }}</nuxt-link>
    <span v-else class="user-text">{{ userName }}</span>
    <span> liked your video {{ addDateFormatted }}</span>
  </template>

  <template v-else-if="notification.type === NotificationType.LikeMyWeek">
    <nuxt-link v-if="userLink" :to="userLink" class="user-link">{{ userName }}</nuxt-link>
    <span v-else class="user-text">{{ userName }}</span>
    <span> liked your diary {{ addDateFormatted }} - </span>
    <nuxt-link v-if="diaryLink" :to="diaryLink" class="diary-link">{{ diaryName }}</nuxt-link>
    <span v-else class="diary-text">{{ diaryName }}</span>
  </template>

  <template v-else-if="notification.type === NotificationType.MentionComment">
    <nuxt-link v-if="userLink" :to="userLink" class="user-link">{{ userName }}</nuxt-link>
    <span v-else class="user-text">{{ userName }}</span>
    <span> mentioned you in a comment {{ addDateFormatted }}</span>
  </template>

  <template v-else-if="notification.type === NotificationType.ModerateCommentMyComplain">
    <span>Your complaint of comment has been moderated {{ addDateFormatted }}</span>
  </template>

  <template v-else-if="notification.type === NotificationType.ModerateDiaryMyComplain">
    <span>Your complaint of diary has been moderated {{ addDateFormatted }} - </span>
    <nuxt-link v-if="diaryLink" :to="diaryLink" class="diary-link">{{ diaryName }}</nuxt-link>
    <span v-else class="diary-text">{{ diaryName }}</span>
  </template>

  <template v-else-if="notification.type === NotificationType.ModerateProfileMyComplain">
    <span>Your complaint of profile has been moderated {{ addDateFormatted }}</span>
  </template>

  <template v-else-if="notification.type === NotificationType.ModerateVideoMyComplain">
    <span>Your complaint of video has been moderated {{ addDateFormatted }}</span>
  </template>

  <template v-else-if="notification.type === NotificationType.NoticeCongrantsDiary">
    <span>Congratulations with harvested diary {{ addDateFormatted }} - </span>
    <nuxt-link v-if="diaryLink" :to="diaryLink" class="diary-link">{{ diaryName }}</nuxt-link>
    <span v-else class="diary-text">{{ diaryName }}</span>
  </template>

  <template v-else-if="notification.type === NotificationType.NoticeNewWeek">
    <span>Time to update your diary {{ addDateFormatted }} - </span>
    <nuxt-link v-if="diaryLink" :to="diaryLink" class="diary-link">{{ diaryName }}</nuxt-link>
    <span v-else class="diary-text">{{ diaryName }}</span>
  </template>

  <template v-else-if="notification.type === NotificationType.NoticeNextDiary">
    <span>Your last diary was epic! Create your next one!</span>
  </template>

  <template v-else-if="notification.type === NotificationType.NoticeStartDiary">
    <span>Congratulations with starting your first diary!</span>
  </template>

  <template v-else-if="notification.type === NotificationType.ReplyMyComment">
    <nuxt-link v-if="userLink" :to="userLink" class="user-link">{{ userName }}</nuxt-link>
    <span v-else class="user-text">{{ userName }}</span>
    <span> replied to your comment {{ addDateFormatted }}</span>
  </template>

  <template v-else-if="notification.type === NotificationType.SelectMySolution">
    <nuxt-link v-if="userLink" :to="userLink" class="user-link">{{ userName }}</nuxt-link>
    <span v-else class="user-text">{{ userName }}</span>
    <span> selected your answer as correct for </span>
    <nuxt-link v-if="problemLink" :to="problemLink" class="problem-link">{{ problemTitle }}</nuxt-link>
    <span v-else class="problem-text">{{ problemTitle }}</span>
  </template>

  <template v-else-if="notification.type === NotificationType.ShareMyDiary">
    <span>Shared your diary </span>
    <nuxt-link v-if="diaryLink" :to="diaryLink" class="diary-link">{{ diaryName }}</nuxt-link>
    <span v-else class="diary-text">{{ diaryName }}</span>
    <span> with friends!</span>
  </template>

  <template v-else-if="notification.type === NotificationType.ShareMyVideo">
    <span>Shared your video with friends!</span>
  </template>

  <!-- Default fallback -->
  <template v-else>
    <span>{{ fallbackText }}</span>
  </template>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import type { NotificationItem, NotificationGroup } from '@/types/notification'
import { NotificationType } from '@/types/notification'

const props = defineProps<{ 
  notification: NotificationItem | NotificationGroup 
}>()

const { $dayjs } = useNuxtApp() as any

// Computed properties for extracting data from context
const addDateFormatted = computed(() => {
  return $dayjs(props.notification.add_date).utc().fromNow()
})

// User context
const userName = computed(() => props.notification.contexts.item_user?.name || 'User')
const userLink = computed(() => props.notification.contexts.item_user?.link || null)

// Diary context  
const diaryName = computed(() => props.notification.contexts.item_diary?.name || 'diary')
const diaryLink = computed(() => props.notification.contexts.item_diary?.link || null)

// Brand context
const brandName = computed(() => props.notification.contexts.item_brand?.name || 'Brand')
const brandLink = computed(() => props.notification.contexts.item_brand?.link || null)

// Product context
const productName = computed(() => props.notification.contexts.item_product?.name || 'product')
const productLink = computed(() => props.notification.contexts.item_product?.link || null)

// Problem/Question context
const problemTitle = computed(() => props.notification.contexts.item_problem?.title || 'question')
const problemLink = computed(() => props.notification.contexts.item_problem?.link || null)

// Blog context
const blogName = computed(() => props.notification.contexts.item_blog?.title || 'blog')
const blogLink = computed(() => props.notification.contexts.item_blog?.link || null)


// Contest/Giveaway context
const contestName = computed(() => props.notification.contexts.item_giveaway?.name || (props.notification.contexts as any).item_contest?.name || 'contest')

// Fallback text
const fallbackText = computed(() => {
  return props.notification.type.replace(/_/g, ' ').replace(/^\w/, c => c.toUpperCase())
})
</script>

<style scoped>
.user-link,
.diary-link,
.brand-link,
.product-link,
.problem-link {
  color: var(--accent);
  text-decoration: none;
  font-weight: 600;
  transition: color 0.2s ease;
}

.user-link:hover,
.diary-link:hover,
.brand-link:hover,
.product-link:hover,
.problem-link:hover {
  color: var(--accent-hover);
  text-decoration: underline;
}

.user-text,
.blog-text,
.diary-text,
.brand-text,
.product-text,
.problem-text {
  font-weight: 600;
  color: var(--text-primary);
}
</style>